import { defineComponent as st, watchEffect as dt, ref as C, computed as l, watch as $, toRef as ct, nextTick as Z, provide as mt, h as g, Transition as ft, withDirectives as ht } from "vue";
import vt from "./ghl-ui.es1081.js";
import { strictParse as de } from "./ghl-ui.es929.js";
import gt from "./ghl-ui.es1082.js";
import { timePickerInjectionKey as pt } from "./ghl-ui.es1083.js";
import { isTimeInStep as B, findSimilarTime as Tt } from "./ghl-ui.es1084.js";
import Ft from "./ghl-ui.es1085.js";
import { warnOnce as Ct } from "./ghl-ui.es825.js";
import Vt from "./ghl-ui.es826.js";
import bt from "./ghl-ui.es879.js";
import It from "./ghl-ui.es861.js";
import ve from "./ghl-ui.es827.js";
import St from "./ghl-ui.es700.js";
import wt from "./ghl-ui.es941.js";
import Rt from "./ghl-ui.es696.js";
import z from "./ghl-ui.es1086.js";
import { useThemeClass as ce } from "./ghl-ui.es829.js";
import yt from "./ghl-ui.es697.js";
import kt from "./ghl-ui.es196.js";
import Dt from "./ghl-ui.es834.js";
import Pt from "./ghl-ui.es1087.js";
import zt from "./ghl-ui.es702.js";
import At from "./ghl-ui.es1088.js";
import { call as c } from "./ghl-ui.es866.js";
import { markEventEffectPerformed as me } from "./ghl-ui.es940.js";
import { happensIn as Ht } from "./ghl-ui.es909.js";
import s from "./ghl-ui.es943.js";
import V from "./ghl-ui.es1089.js";
import Mt from "./ghl-ui.es1090.js";
import L from "./ghl-ui.es1091.js";
import xt from "./ghl-ui.es1092.js";
import q from "./ghl-ui.es1093.js";
import Bt from "./ghl-ui.es1094.js";
import { getPreciseEventTarget as Nt } from "./ghl-ui.es881.js";
import Ut from "./ghl-ui.es942.js";
import Ot from "./ghl-ui.es1095.js";
import fe from "./ghl-ui.es1096.js";
import he from "./ghl-ui.es1097.js";
import _t from "./ghl-ui.es1098.js";
import { useAdjustedTo as G } from "./ghl-ui.es883.js";
import Et from "./ghl-ui.es884.js";
import Kt from "./ghl-ui.es885.js";
import jt from "./ghl-ui.es886.js";
function W(n, T) {
  return n === void 0 ? !0 : Array.isArray(n) ? n.every((d) => d >= 0 && d <= T) : n >= 0 && n <= T;
}
const $t = Object.assign(Object.assign({}, ve.props), {
  to: G.propTo,
  bordered: {
    type: Boolean,
    default: void 0
  },
  actions: Array,
  defaultValue: {
    type: Number,
    default: null
  },
  defaultFormattedValue: String,
  placeholder: String,
  placement: {
    type: String,
    default: "bottom-start"
  },
  value: Number,
  format: {
    type: String,
    default: "HH:mm:ss"
  },
  valueFormat: String,
  formattedValue: String,
  isHourDisabled: Function,
  size: String,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  inputReadonly: Boolean,
  clearable: Boolean,
  status: String,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  "onUpdate:show": [Function, Array],
  onUpdateShow: [Function, Array],
  onUpdateFormattedValue: [Function, Array],
  "onUpdate:formattedValue": [Function, Array],
  onBlur: [Function, Array],
  onConfirm: [Function, Array],
  onClear: Function,
  onFocus: [Function, Array],
  // https://www.iana.org/time-zones
  timeZone: String,
  showIcon: {
    type: Boolean,
    default: !0
  },
  disabled: {
    type: Boolean,
    default: void 0
  },
  show: {
    type: Boolean,
    default: void 0
  },
  hours: {
    type: [Number, Array],
    validator: (n) => W(n, 23)
  },
  minutes: {
    type: [Number, Array],
    validator: (n) => W(n, 59)
  },
  seconds: {
    type: [Number, Array],
    validator: (n) => W(n, 59)
  },
  use12Hours: Boolean,
  // private
  stateful: {
    type: Boolean,
    default: !0
  },
  // deprecated
  onChange: [Function, Array]
}), xn = st({
  name: "TimePicker",
  props: $t,
  setup(n) {
    process.env.NODE_ENV !== "production" && dt(() => {
      n.onChange !== void 0 && Ct("time-picker", "`on-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedBorderedRef: T,
      mergedClsPrefixRef: d,
      namespaceRef: k,
      inlineThemeDisabled: A
    } = Vt(n), {
      localeRef: D,
      dateLocaleRef: ge
    } = bt("TimePicker"), H = It(n), {
      mergedSizeRef: pe,
      mergedDisabledRef: M,
      mergedStatusRef: Te
    } = H, x = ve("TimePicker", "-time-picker", Ft, At, n, d), Fe = St(), b = C(null), I = C(null), F = l(() => ({
      locale: ge.value.locale
    }));
    function J(e) {
      return e === null ? null : de(e, n.valueFormat || n.format, /* @__PURE__ */ new Date(), F.value).getTime();
    }
    const {
      defaultValue: Ce,
      defaultFormattedValue: Q
    } = n, N = C(Q !== void 0 ? J(Q) : Ce), r = l(() => {
      const {
        formattedValue: e
      } = n;
      if (e !== void 0)
        return J(e);
      const {
        value: t
      } = n;
      return t !== void 0 ? t : N.value;
    }), S = l(() => {
      const {
        timeZone: e
      } = n;
      return e ? (t, i, o) => vt(t, e, i, o) : (t, i, o) => wt(t, i, o);
    }), P = C("");
    $(() => n.timeZone, () => {
      const e = r.value;
      P.value = e === null ? "" : S.value(e, n.format, F.value);
    }, {
      immediate: !0
    });
    const X = C(!1), Ve = ct(n, "show"), m = Rt(Ve, X), U = C(r.value), O = C(!1), be = l(() => D.value.clear), Ie = l(() => D.value.now), Se = l(() => n.placeholder !== void 0 ? n.placeholder : D.value.placeholder), we = l(() => D.value.negativeText), Re = l(() => D.value.positiveText), ye = l(() => /H|h|K|k/.test(n.format)), ke = l(() => n.format.includes("m")), De = l(() => n.format.includes("s")), Y = l(() => {
      const {
        isHourDisabled: e
      } = n;
      return w.value === null ? !1 : B(w.value, "hours", n.hours) ? e ? e(w.value) : !1 : !0;
    }), ee = l(() => {
      const {
        value: e
      } = _, {
        value: t
      } = w;
      if (e === null || t === null)
        return !1;
      if (!B(e, "minutes", n.minutes))
        return !0;
      const {
        isMinuteDisabled: i
      } = n;
      return i ? i(e, t) : !1;
    }), te = l(() => {
      const {
        value: e
      } = _, {
        value: t
      } = w, {
        value: i
      } = ie;
      if (i === null || e === null || t === null)
        return !1;
      if (!B(i, "seconds", n.seconds))
        return !0;
      const {
        isSecondDisabled: o
      } = n;
      return o ? o(i, e, t) : !1;
    }), ne = l(() => Y.value || ee.value || te.value), Pe = l(() => n.format.length + 4), ze = l(() => {
      const {
        value: e
      } = r;
      return e === null ? null : z(e) < 12 ? "am" : "pm";
    }), w = l(() => {
      const {
        value: e
      } = r;
      return e === null ? null : Number(S.value(e, "HH", F.value));
    }), _ = l(() => {
      const {
        value: e
      } = r;
      return e === null ? null : Number(S.value(e, "mm", F.value));
    }), ie = l(() => {
      const {
        value: e
      } = r;
      return e === null ? null : Number(S.value(e, "ss", F.value));
    });
    function Ae(e, t) {
      const {
        onUpdateFormattedValue: i,
        "onUpdate:formattedValue": o
      } = n;
      i && c(i, e, t), o && c(o, e, t);
    }
    function oe(e) {
      return e === null ? null : S.value(e, n.valueFormat || n.format);
    }
    function a(e) {
      const {
        onUpdateValue: t,
        "onUpdate:value": i,
        onChange: o
      } = n, {
        nTriggerFormChange: h,
        nTriggerFormInput: v
      } = H, u = oe(e);
      t && c(t, e, u), i && c(i, e, u), o && c(o, e, u), Ae(u, e), N.value = e, h(), v();
    }
    function He(e) {
      const {
        onFocus: t
      } = n, {
        nTriggerFormFocus: i
      } = H;
      t && c(t, e), i();
    }
    function E(e) {
      const {
        onBlur: t
      } = n, {
        nTriggerFormBlur: i
      } = H;
      t && c(t, e), i();
    }
    function Me() {
      const {
        onConfirm: e
      } = n;
      e && c(e, r.value, oe(r.value));
    }
    function xe(e) {
      var t;
      e.stopPropagation(), a(null), p(null), (t = n.onClear) === null || t === void 0 || t.call(n);
    }
    function Be() {
      f({
        returnFocus: !0
      });
    }
    function Ne() {
      a(null), p(null), f({
        returnFocus: !0
      });
    }
    function Ue(e) {
      e.key === "Escape" && m.value && me(e);
    }
    function Oe(e) {
      var t;
      switch (e.key) {
        case "Escape":
          m.value && (me(e), f({
            returnFocus: !0
          }));
          break;
        case "Tab":
          Fe.shift && e.target === ((t = I.value) === null || t === void 0 ? void 0 : t.$el) && (e.preventDefault(), f({
            returnFocus: !0
          }));
          break;
      }
    }
    function _e() {
      O.value = !0, Z(() => {
        O.value = !1;
      });
    }
    function Ee(e) {
      M.value || Ht(e, "clear") || m.value || le();
    }
    function Ke(e) {
      typeof e != "string" && (r.value === null ? a(s(V(Mt(/* @__PURE__ */ new Date()), e))) : a(s(V(r.value, e))));
    }
    function je(e) {
      typeof e != "string" && (r.value === null ? a(s(L(xt(/* @__PURE__ */ new Date()), e))) : a(s(L(r.value, e))));
    }
    function $e(e) {
      typeof e != "string" && (r.value === null ? a(s(q(Bt(/* @__PURE__ */ new Date()), e))) : a(s(q(r.value, e))));
    }
    function Ze(e) {
      const {
        value: t
      } = r;
      if (t === null) {
        const i = /* @__PURE__ */ new Date(), o = z(i);
        e === "pm" && o < 12 ? a(s(V(i, o + 12))) : e === "am" && o >= 12 && a(s(V(i, o - 12))), a(s(i));
      } else {
        const i = z(t);
        e === "pm" && i < 12 ? a(s(V(t, i + 12))) : e === "am" && i >= 12 && a(s(V(t, i - 12)));
      }
    }
    function p(e) {
      e === void 0 && (e = r.value), e === null ? P.value = "" : P.value = S.value(e, n.format, F.value);
    }
    function Le(e) {
      j(e) || He(e);
    }
    function qe(e) {
      var t;
      if (!j(e))
        if (m.value) {
          const i = (t = I.value) === null || t === void 0 ? void 0 : t.$el;
          i != null && i.contains(e.relatedTarget) || (p(), E(e), f({
            returnFocus: !1
          }));
        } else
          p(), E(e);
    }
    function We() {
      M.value || m.value || le();
    }
    function Ge() {
      M.value || (p(), f({
        returnFocus: !1
      }));
    }
    function re() {
      if (!I.value)
        return;
      const {
        hourScrollRef: e,
        minuteScrollRef: t,
        secondScrollRef: i,
        amPmScrollRef: o
      } = I.value;
      [e, t, i, o].forEach((h) => {
        var v;
        if (!h)
          return;
        const u = (v = h.contentRef) === null || v === void 0 ? void 0 : v.querySelector("[data-active]");
        u && h.scrollTo({
          top: u.offsetTop
        });
      });
    }
    function K(e) {
      X.value = e;
      const {
        onUpdateShow: t,
        "onUpdate:show": i
      } = n;
      t && c(t, e), i && c(i, e);
    }
    function j(e) {
      var t, i, o;
      return !!(!((i = (t = b.value) === null || t === void 0 ? void 0 : t.wrapperElRef) === null || i === void 0) && i.contains(e.relatedTarget) || !((o = I.value) === null || o === void 0) && o.$el.contains(e.relatedTarget));
    }
    function le() {
      U.value = r.value, K(!0), Z(re);
    }
    function Je(e) {
      var t, i;
      m.value && !(!((i = (t = b.value) === null || t === void 0 ? void 0 : t.wrapperElRef) === null || i === void 0) && i.contains(Nt(e))) && f({
        returnFocus: !1
      });
    }
    function f({
      returnFocus: e
    }) {
      var t;
      m.value && (K(!1), e && ((t = b.value) === null || t === void 0 || t.focus()));
    }
    function Qe(e) {
      if (e === "") {
        a(null);
        return;
      }
      const t = de(e, n.format, /* @__PURE__ */ new Date(), F.value);
      if (P.value = e, Ut(t)) {
        const {
          value: i
        } = r;
        if (i !== null) {
          const o = Ot(i, {
            hours: z(t),
            minutes: fe(t),
            seconds: he(t),
            milliseconds: _t(t)
          });
          a(s(o));
        } else
          a(s(t));
      }
    }
    function Xe() {
      a(U.value), K(!1);
    }
    function Ye() {
      const e = /* @__PURE__ */ new Date(), t = {
        hours: z,
        minutes: fe,
        seconds: he
      }, [i, o, h] = ["hours", "minutes", "seconds"].map((u) => !n[u] || B(t[u](e), u, n[u]) ? t[u](e) : Tt(t[u](e), u, n[u])), v = q(L(V(r.value ? r.value : s(e), i), o), h);
      a(s(v));
    }
    function et() {
      p(), Me(), f({
        returnFocus: !0
      });
    }
    function tt(e) {
      j(e) || (p(), E(e), f({
        returnFocus: !1
      }));
    }
    $(r, (e) => {
      p(e), _e(), Z(re);
    }), $(m, () => {
      ne.value && a(U.value);
    }), mt(pt, {
      mergedThemeRef: x,
      mergedClsPrefixRef: d
    });
    const ae = {
      focus: () => {
        var e;
        (e = b.value) === null || e === void 0 || e.focus();
      },
      blur: () => {
        var e;
        (e = b.value) === null || e === void 0 || e.blur();
      }
    }, ue = l(() => {
      const {
        common: {
          cubicBezierEaseInOut: e
        },
        self: {
          iconColor: t,
          iconColorDisabled: i
        }
      } = x.value;
      return {
        "--n-icon-color-override": t,
        "--n-icon-color-disabled-override": i,
        "--n-bezier": e
      };
    }), R = A ? ce("time-picker-trigger", void 0, ue, n) : void 0, se = l(() => {
      const {
        self: {
          panelColor: e,
          itemTextColor: t,
          itemTextColorActive: i,
          itemColorHover: o,
          panelDividerColor: h,
          panelBoxShadow: v,
          itemOpacityDisabled: u,
          borderRadius: nt,
          itemFontSize: it,
          itemWidth: ot,
          itemHeight: rt,
          panelActionPadding: lt,
          itemBorderRadius: at
        },
        common: {
          cubicBezierEaseInOut: ut
        }
      } = x.value;
      return {
        "--n-bezier": ut,
        "--n-border-radius": nt,
        "--n-item-color-hover": o,
        "--n-item-font-size": it,
        "--n-item-height": rt,
        "--n-item-opacity-disabled": u,
        "--n-item-text-color": t,
        "--n-item-text-color-active": i,
        "--n-item-width": ot,
        "--n-panel-action-padding": lt,
        "--n-panel-box-shadow": v,
        "--n-panel-color": e,
        "--n-panel-divider-color": h,
        "--n-item-border-radius": at
      };
    }), y = A ? ce("time-picker", void 0, se, n) : void 0;
    return {
      focus: ae.focus,
      blur: ae.blur,
      mergedStatus: Te,
      mergedBordered: T,
      mergedClsPrefix: d,
      namespace: k,
      uncontrolledValue: N,
      mergedValue: r,
      isMounted: yt(),
      inputInstRef: b,
      panelInstRef: I,
      adjustedTo: G(n),
      mergedShow: m,
      localizedClear: be,
      localizedNow: Ie,
      localizedPlaceholder: Se,
      localizedNegativeText: we,
      localizedPositiveText: Re,
      hourInFormat: ye,
      minuteInFormat: ke,
      secondInFormat: De,
      mergedAttrSize: Pe,
      displayTimeString: P,
      mergedSize: pe,
      mergedDisabled: M,
      isValueInvalid: ne,
      isHourInvalid: Y,
      isMinuteInvalid: ee,
      isSecondInvalid: te,
      transitionDisabled: O,
      hourValue: w,
      minuteValue: _,
      secondValue: ie,
      amPmValue: ze,
      handleInputKeydown: Ue,
      handleTimeInputFocus: Le,
      handleTimeInputBlur: qe,
      handleNowClick: Ye,
      handleConfirmClick: et,
      handleTimeInputUpdateValue: Qe,
      handleMenuFocusOut: tt,
      handleCancelClick: Xe,
      handleClickOutside: Je,
      handleTimeInputActivate: We,
      handleTimeInputDeactivate: Ge,
      handleHourClick: Ke,
      handleMinuteClick: je,
      handleSecondClick: $e,
      handleAmPmClick: Ze,
      handleTimeInputClear: xe,
      handleFocusDetectorFocus: Be,
      handleMenuKeydown: Oe,
      handleTriggerClick: Ee,
      mergedTheme: x,
      triggerCssVars: A ? void 0 : ue,
      triggerThemeClass: R == null ? void 0 : R.themeClass,
      triggerOnRender: R == null ? void 0 : R.onRender,
      cssVars: A ? void 0 : se,
      themeClass: y == null ? void 0 : y.themeClass,
      onRender: y == null ? void 0 : y.onRender,
      clearSelectedValue: Ne
    };
  },
  render() {
    const {
      mergedClsPrefix: n,
      $slots: T,
      triggerOnRender: d
    } = this;
    return d == null || d(), g("div", {
      class: [`${n}-time-picker`, this.triggerThemeClass],
      style: this.triggerCssVars
    }, g(Et, null, {
      default: () => [g(Kt, null, {
        default: () => g(kt, {
          ref: "inputInstRef",
          status: this.mergedStatus,
          value: this.displayTimeString,
          bordered: this.mergedBordered,
          passivelyActivated: !0,
          attrSize: this.mergedAttrSize,
          theme: this.mergedTheme.peers.Input,
          themeOverrides: this.mergedTheme.peerOverrides.Input,
          stateful: this.stateful,
          size: this.mergedSize,
          placeholder: this.localizedPlaceholder,
          clearable: this.clearable,
          disabled: this.mergedDisabled,
          textDecoration: this.isValueInvalid ? "line-through" : void 0,
          onFocus: this.handleTimeInputFocus,
          onBlur: this.handleTimeInputBlur,
          onActivate: this.handleTimeInputActivate,
          onDeactivate: this.handleTimeInputDeactivate,
          onUpdateValue: this.handleTimeInputUpdateValue,
          onClear: this.handleTimeInputClear,
          internalDeactivateOnEnter: !0,
          internalForceFocus: this.mergedShow,
          readonly: this.inputReadonly || this.mergedDisabled,
          onClick: this.handleTriggerClick,
          onKeydown: this.handleInputKeydown
        }, this.showIcon ? {
          [this.clearable ? "clear-icon-placeholder" : "suffix"]: () => g(Dt, {
            clsPrefix: n,
            class: `${n}-time-picker-icon`
          }, {
            default: () => T.icon ? T.icon() : g(Pt, null)
          })
        } : null)
      }), g(jt, {
        teleportDisabled: this.adjustedTo === G.tdkey,
        show: this.mergedShow,
        to: this.adjustedTo,
        containerClass: this.namespace,
        placement: this.placement
      }, {
        default: () => g(ft, {
          name: "fade-in-scale-up-transition",
          appear: this.isMounted
        }, {
          default: () => {
            var k;
            return this.mergedShow ? ((k = this.onRender) === null || k === void 0 || k.call(this), ht(g(gt, {
              ref: "panelInstRef",
              actions: this.actions,
              class: this.themeClass,
              style: this.cssVars,
              seconds: this.seconds,
              minutes: this.minutes,
              hours: this.hours,
              transitionDisabled: this.transitionDisabled,
              hourValue: this.hourValue,
              showHour: this.hourInFormat,
              isHourInvalid: this.isHourInvalid,
              isHourDisabled: this.isHourDisabled,
              minuteValue: this.minuteValue,
              showMinute: this.minuteInFormat,
              isMinuteInvalid: this.isMinuteInvalid,
              isMinuteDisabled: this.isMinuteDisabled,
              secondValue: this.secondValue,
              amPmValue: this.amPmValue,
              showSecond: this.secondInFormat,
              isSecondInvalid: this.isSecondInvalid,
              isSecondDisabled: this.isSecondDisabled,
              isValueInvalid: this.isValueInvalid,
              clearText: this.localizedClear,
              nowText: this.localizedNow,
              confirmText: this.localizedPositiveText,
              use12Hours: this.use12Hours,
              onFocusout: this.handleMenuFocusOut,
              onKeydown: this.handleMenuKeydown,
              onHourClick: this.handleHourClick,
              onMinuteClick: this.handleMinuteClick,
              onSecondClick: this.handleSecondClick,
              onAmPmClick: this.handleAmPmClick,
              onNowClick: this.handleNowClick,
              onConfirmClick: this.handleConfirmClick,
              onClearClick: this.clearSelectedValue,
              onFocusDetectorFocus: this.handleFocusDetectorFocus
            }), [[zt, this.handleClickOutside, void 0, {
              capture: !0
            }]])) : null;
          }
        })
      })]
    }));
  }
});
export {
  xn as default,
  $t as timePickerProps
};
